import React from "react";
import {Card} from "antd";

const LegendList = (props,{
	onClick,innerStyle,cardStyle}) => {
	return (
		<Card style={innerStyle}>
			<p>{props.header}</p>
			{props.children}
		</Card>
	);

};

export default LegendList;


// WEBPACK FOOTER //
// ./src/components/form/LegendList.js